<template>
    <div
        class="sidebar-box animated fadeIn"
        :class="{ 'toggle-off': !isOpen }"
        :data-toggle-remember="id"
    >
        <h3
            class="toggle"
            @click="toggle()"
        >
            <i
                class="icon"
                :class="{ 'icon-caret-down': isOpen, 'icon-caret-right': !isOpen }"
            ></i>
            <div>{{ title }}</div>
        </h3>
        <div class="content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isOpen: true,
        }
    },
    mounted() {
        let data = window.localStorage.getItem('sidebar');
        let sidebar = data ? JSON.parse(data) : {};
        if (sidebar[this.id]) {
            this.isOpen = false;
            $(this.$el).find('.content').hide();
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;

            let box = $(this.$el);
            if (this.isOpen) {
                box.find('.content').slideDown();
            } else {
                box.find('.content').slideUp();
            }
            let data = window.localStorage.getItem('sidebar');
            let sidebar = data ? JSON.parse(data) : {};
            sidebar[this.id] = !this.isOpen;
            window.localStorage.setItem('sidebar', JSON.stringify(sidebar));
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .sidebar-box:first-of-type {
        border-top: 1px solid #c6c6c6;
    }
    .sidebar-box {
        border-bottom: 1px solid #c6c6c6;
        .toggle {
            padding: 6px 20px;
            margin: 0;
            cursor: pointer;
            display: flex;
            i {
                margin-right: 5px;
            }
        }
        &.toggle-off {
            .toggle {
                color: #383838;
            }
        }
        &:not(.toggle-off) {
            .toggle {
                background-color: var(--kgr-color-accent);
                color: var(--kgr-color-accent-inverted);
            }
        }
        .content {
            padding: 16px 24px;
        }
    }
</style>
